__turbopack_context__.v({
  "bannerHalf": "_43XmFq_bannerHalf",
  "buttonText": "_43XmFq_buttonText",
  "buttonWrapper": "_43XmFq_buttonWrapper",
  "container": "_43XmFq_container",
  "contentWrapper": "_43XmFq_contentWrapper",
  "headingWrapper": "_43XmFq_headingWrapper",
  "heroSection": "_43XmFq_heroSection",
  "imageWrapper": "_43XmFq_imageWrapper",
  "splitBannerSection": "_43XmFq_splitBannerSection",
  "splitTextContainer": "_43XmFq_splitTextContainer",
  "splitTextItem": "_43XmFq_splitTextItem",
  "stickyContainer": "_43XmFq_stickyContainer",
  "stickyWrapper": "_43XmFq_stickyWrapper",
  "styledImage": "_43XmFq_styledImage",
  "textWrapper": "_43XmFq_textWrapper",
  "titleWrapper": "_43XmFq_titleWrapper",
});
